import printJs from "print-js";
import {ApiManager} from "../api/ApiManager";
import {AlbusUrlConfigs} from "../api/AlbusUrlConfigs";

export class PrescriptionAction {
    static uploadPrescription(id: number, file: File, type: string) {
        ApiManager.getAlbusApis().uploadPrescription(id, file, type);
    }

    static downloadPrescription(id: number, type: string) {
        let currUrl = AlbusUrlConfigs.createDownloadPrescriptionUrl(id, type);
        window.open(currUrl, "_blank");
    }

    static printPrescription(id: number, type: string) {
        let currUrl = AlbusUrlConfigs.createDownloadPrescriptionUrl(id, type);
        printJs({printable: currUrl, type: "pdf"})
    }

    static sendPrescription(bookingId: number, appointmentId: number) {
        return ApiManager.getAlbusApis().emailPrescription(bookingId, appointmentId);
    }

    static sendPlan(appointmentId: number, curefitUserId: string, bookingId: number) {
        return ApiManager.getAlbusApis().emailPlan(appointmentId, curefitUserId, bookingId);
    }
}